import { Feature, getProductId, PlanInterval } from '../../../../models';

const TRUE_BUNDLE_ECOM_PRODUCT_IDS: Partial<Record<Feature, string>> = {
  [Feature.TRUE_AUTOMATION]: 'true_automation_ecom',
  [Feature.TRUE_PLATFORM_ONLY]: 'true_platform_ecom',
  // True Bundle Starters exist ONLY on the eCom channel and only annually; the direct-sale
  // siblings (`true_bundle_*_annual|_2years|_3years`) are seeded with PR 2.
  [Feature.TRUE_BUNDLE_MANUAL]: 'true_bundle_manual_ecom',
  [Feature.TRUE_BUNDLE_AUTOMATION]: 'true_bundle_automation_ecom',
};

const getManualPurchaseProductId = (
  feature: Feature,
  interval: PlanInterval,
): string => (interval === PlanInterval.YEAR
  ? TRUE_BUNDLE_ECOM_PRODUCT_IDS[feature] ?? getProductId(feature)
  : getProductId(feature));

export const getManualPurchaseProductCode = (
  feature: Feature,
  interval: PlanInterval,
): string => `${getManualPurchaseProductId(feature, interval)}_${PlanInterval.getPlanIntervalCode(interval)}`;
